import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { ITrainingUserPositionGroup } from 'src/app/shared/services/user/user.type';
import { Router, RouterLink } from '@angular/router';
import { ITrainingStage } from 'src/app/shared/services/training/training.type';
import { befreeUrlValues } from 'src/app/shared/constants';
import { TextSizes, TextType, TrainingPageType } from 'src/app/shared/enums';
import { LinkNav } from 'src/app/shared/interfaces';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { IonicModule } from '@ionic/angular';
import { TextComponent } from '../text/text.component';

@Component({
  selector: 'app-section-card',
  templateUrl: './section-card.component.html',
  styleUrls: ['./section-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, RouterLink, TextComponent],
})
export class SectionCardComponent implements OnInit {
  utils = inject(UtilsService);
  private _router = inject(Router);

  @Input() navigation!: LinkNav;

  @Input() section?: ITrainingUserPositionGroup | undefined;

  @Input() stage?: ITrainingStage | undefined;

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public currentPage: string = typeof befreeUrlValues;

  public ngOnInit() {
    if (this._router.url.includes(befreeUrlValues.sections))
      this.currentPage = TrainingPageType.sections;
    else {
      this.currentPage = TrainingPageType.section;
    }
  }
}
